import React, { forwardRef, useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { useAxiosInvicePrint } from "../api/api";
import { useParams, useNavigate } from "react-router-dom";

const html = `
<html>
  <head>
    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no" />
  </head>
  <body style="text-align: center;">
    <h1 style="font-size: 50px; font-family: Helvetica Neue; font-weight: normal;">
      Hello Expo!
    </h1>
    <img
      src="https://d30j33t1r58ioz.cloudfront.net/static/guides/sdk.png"
      style="width: 90vw;" />
  </body>
</html>
`;

const PrintPage = () => {
  const ref = useRef(null);
  const { itemNo } = useParams();

  const handlePrint = useReactToPrint({
    content: () => ref.current,
    bodyClass: "print-agreement",
  });



  const [companyData, setCompanyData] = useState("");
  // const getCampanyData = async (companyId) => {
  //   const { data } = await instance.get(
  //     `/companies/get-company-ecommerce/${companyId}`
  //   );
  //   // console.log("data: ", data);
  //   setCompanyData(data);
  // };
  // const [loading1, setLoading1] = useState(true);

  const { data1, data2, data3, data4, loading, error } = useAxiosInvicePrint(
    {
      method: "GET",
      url: `/invoices/transition-ref/search?itemNo=${itemNo}`,
      headers: {
        accept: "*/*",
      },
    },
    {
      method: "GET",
      url: `/orders/getOrder/`,
      headers: {
        accept: "*/*",
      },
    },
    {
      method: "GET",
      url: `/users/login/`,
      headers: {
        accept: "*/*",
      },
    },
    {
      method: "GET",
      url: `/companies/get-company-ecommerce/`,
      headers: {
        accept: "*/*",
      },
    }
  );

  // useEffect(() => {
  //   if (loading) {
  //     getCampanyData(data1?.company_id).then(() => {
  //       setLoading1(false);
  //       console.log("here ok ..");
  //     });
  //     loading == false && printToFile();
  //   }
  // }, [loading]);

  useEffect(() => {
    loading == false && handlePrint();
  }, [loading]);

  return (
    <>
      {loading ? (
        <div className="flex items-center justify-center w-full py-20">
          <div className="flex justify-center items-center space-x-1 rtl:space-x-reverse text-sm text-gray-700">
            <svg
              fill="none"
              className="w-20 h-20 animate-spin"
              viewBox="0 0 32 32"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                clipRule="evenodd"
                d="M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z"
                fill="currentColor"
                fillRule="evenodd"
              />
            </svg>
          </div>
        </div>
      ) : (
        <div
          ref={ref}
          className="bg-white rounded-lg shadow-lg px-8 py-10 sm:max-w-3xl mx-auto w-full rtl:text-right"
        >
          <div className="flex items-center justify-between mb-8">
            <div className="text-gray-700 mt-4 ">
              <div className="font-bold text-xl mb-2">فاتورة</div>
              <div className="text-sm">
                التاريخ:{" "}
                {new Date(data1.created_at).getFullYear() +
                  "/" +
                  new Date(data1.created_at).getMonth() +
                  "/" +
                  new Date(data1.created_at).getDay()}
              </div>
              <div className="text-sm">رقم الطلب: {data1.itemNo}</div>
            </div>
            <div className="flex items-center gap-2 -mt-8">
              <img
                className="h-5 w-5 mr-2"
                src="https://tailwindflex.com/public/images/logos/favicon-32x32.png"
                alt="Logo"
              />
              <div className="text-gray-700 font-semibold text-lg">
                {data4.companyName.length > 0
                  ? data4.companyName.toUpperCase()
                  : "MERCHANT"}
              </div>
            </div>
          </div>
          <div className="border-b-2 border-gray-300 pb-8 mb-8">
            <h2 className="text-2xl font-bold mb-4">الفاتورة إلى:</h2>
            <div className="text-gray-700 mb-2">{data3.displayName1}</div>
            <div className="text-gray-700 mb-2">{data3.address}.</div>
            <div className="text-gray-700 mb-2">{data3.city}</div>
            <div className="text-gray-700">{data3.email}</div>
          </div>
          <table className="w-full mb-8 ">
            <thead>
              <tr>
                <th className="text-gray-700 font-bold uppercase py-2">
                  اسم المنتج
                </th>
                <th className="text-gray-700 font-bold uppercase py-2">
                  الكمية
                </th>
                <th className="text-gray-700 font-bold uppercase py-2">
                  السعر
                </th>
                <th className="text-gray-700 font-bold uppercase py-2">
                  الإجمالي
                </th>
              </tr>
            </thead>
            <tbody>
              {data2?.orders.map((order, key) => (
                <tr key={key}>
                  <td className="py-4 text-gray-700">{order.name}</td>
                  <td className="py-4 text-gray-700">{order.qty}</td>
                  <td className="py-4 text-gray-700">
                    SAR {order.unit.toFixed(2)}
                  </td>
                  <td className="py-4 text-gray-700">
                    SAR {order.unit.toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="flex justify-between mb-8  ">
            <div className="text-gray-700 mr-2">المجموع:</div>
            <div className="text-gray-700 ml-15  w-36">
              SAR {data1.price.toFixed(2)}
            </div>
          </div>
          <div className="flex justify-between mb-8 ">
            <div className="text-gray-700 mr-2 ">الشحن:</div>
            <div className="text-gray-700 w-36 ">SAR 19.99</div>
          </div>
          {/* <div className="text-right mb-8">
            <div className="text-gray-700 mr-2">Tax:</div>
            <div className="text-gray-700">$25.50</div>
          </div> */}
          <div className="flex justify-between mb-8 ">
            <div className="text-gray-700 mr-2">الإجمالي:</div>
            <div className="text-gray-700 w-36  font-bold text-xl">
              SAR {(19.99 + data1.price).toFixed(2)}
            </div>
          </div>
          <div className="border-t-2 border-gray-300 pt-8 mb-8">
            <div className="text-gray-700 mb-2">معلومات المتجر</div>
            <div className="text-gray-700">رقم التواصل: {data4.phone}</div>
            <div className="text-gray-700">
              البريد الإلكتروني: {data4.email}
            </div>
            <div className="text-gray-700">
              العنوان: {data4.address} , {data4.city}, SA {data4.zipCode}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PrintPage;
